import React, { FC, useContext, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Avatar from "./Avatar";
import { GlobalDataContext } from "contexts/GlobalData";
import GuestAvatar from "assets/images/guest.png";

const MeProfile = ({ 
	userData,
	className = "" 
}: any) => {
		
	const { 
		initData,
	} = useContext (GlobalDataContext);

	const role = initData.token_info.permission_group;
	const profileUrl = initData.userInfo.profileUrl;

	const [info, setInfo] = useState({
		user_id: userData._id,
		displayName: userData.displayName,
		profileUrl: (profileUrl === null)
		? 
			GuestAvatar 
		: 
			`${process.env.REACT_APP_SERVER_FILE}/avatar/${userData.profileUrl}?update=${userData.updatedAt}`
	});

	

	useEffect(()=>{
		if (initData.token_info.permission_group === "guest") {
			//user_displayName
		}
	}, []);
	
	
	return (
		<>
			<div className="w-full flex flex-col items-center text-center sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 px-0 sm:p-6 xl:p-8 mt-10">
				<Avatar
					hasCheckedClass="w-6 h-6 -top-0.5 right-2"
					sizeClass="w-28 h-28"
					imgUrl={info.profileUrl}
				/>

				{/* ---- */}
				<div className="space-y-3 text-center flex flex-col items-center">
					<h2 className="text-lg font-semibold">{info.displayName}</h2>
					{/* <StartRating className="!text-base" /> */}
				</div>

				{/* ---- */}
				{/* <SocialsList
					className="!space-x-3"
					itemClass="flex items-center justify-center w-9 h-9 rounded-full bg-neutral-100 dark:bg-neutral-800 text-xl"
				/> */}

				{/* ---- */}
				<div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div>

				
			</div>
		</>
  	);
};

export default MeProfile;
